var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Navbar'),_c('Hero'),_c('About'),_c('Video'),_c('Lyrics'),_c('Food'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }